import { render, staticRenderFns } from "./TheNavbarTopPanelMenu.vue?vue&type=template&id=6f672270&scoped=true&"
import script from "./TheNavbarTopPanelMenu.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanelMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f672270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VMenu})
